/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import styles from '../styles/formFieldUpload.module.scss';

import getFileTypeByMimeType from '../helpers/getFileTypeByMimeType';

const FormFieldUploadPreview = ({ shouldNotDisplayPreview, upload, uploadType = 'document' }) => {
  if (!upload.url) return null;

  const file = (
    <Button
      isExternalLink
      to={upload?.url}
      target="__blank"
      variant="link"
    >
      {upload?.file?.name || upload.name}
    </Button>
  );

  const video = (<video className={styles.video} src={upload.url} controls autoPlay muted />);

  const image = (<img alt={i18n.t('uploaded-image-preview')} src={upload.url} className={styles.image} />);

  const audio = (<audio src={upload.url} controls />);

  const renderPreview = () => {
    const type = uploadType || upload.type || getFileTypeByMimeType(upload?.file?.type);

    switch (type) {
      case 'image':
        return image;
      case 'video':
        return video;
      case 'document':
        return file;
      case 'audio':
        return audio;
      default:
    }
  };

  return (
    <div className={styles.preview}>
      {!shouldNotDisplayPreview && renderPreview()}
    </div>
  );
};

FormFieldUploadPreview.propTypes = {
  upload: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
  uploadType: PropTypes.oneOf(['avatar', 'image', 'document', 'audio', 'video']),
};

export default React.memo(FormFieldUploadPreview);
